import React,{ useState,useEffect} from 'react';
import { Button, Input, Modal } from 'antd';
import './index.scss';


const PCOpenPhoneTrialYearSuccess = ({ visible, onClose, time }: any) => {
    const [count,setCount]=useState(3);
    let timer:any=null
    useEffect(()=>{
        if(visible){
          let countTime = 3
        setInterval(()=>{
          if(countTime==0){
            clearInterval(timer)
            onClose();
          }else{
            countTime=countTime-1
            setCount(countTime)
          }
        },1000)
        }
        return ()=>timer&&clearInterval(timer);
      },[visible])
  return <Modal className='new-pc-trial-input-phone-modal' centered destroyOnClose={true} visible={!!visible} onCancel={onClose} closable={false} footer={null} width={368}>
    <div style={{ paddingBottom: 30, textAlign: 'center' }}>
      <div style={{ marginBottom: 19,paddingTop:9 }}>
        <img src={require('../../assets/new-trial/success.svg')} width={64}/>
      </div>
      <div style={{ fontWeight: 500,fontStyle:'normal', fontSize: 20, marginBottom: 12,color:'#2F2F2F'}}>领取成功</div>
      <div style={{ fontWeight: 400,fontSize: 16,color:'#a0a3a7',padding:'0 26px'}}>{visible==='old'?`${count}s后会自动跳转模板专题`:`您已经获得${time}天会员，${count}s后会自动跳转模板专题`}</div>
    </div>
    <div className={'islide-pc-trial-modal-success-footer'}>
      <Button  onClick={onClose}>确定</Button>
    </div>
  </Modal>;
};

export default PCOpenPhoneTrialYearSuccess;
